import { inject, NewInstance } from 'aurelia-framework';
import { CoatingService } from 'pages/system-fields/coatings/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), CoatingService, EventAggregator)
export class StatusEditor {
    constructor(controller, validationController, coatingService, ea) {
        this.controller = controller;
        this.coatingService = coatingService;
        this.ea = ea;
        this.coating = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.coating = await this.coatingService.getById(model.id);
        }
    }

 

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.coating.id) {
                    await this.coatingService.update(this.coating);
                    toastr.success('Coating was updated!');
                } else {
                    await this.coatingService.create(this.coating);
                    toastr.success('New coating was created!');
                }
                this.ea.publish('coatings:updated', this.coating);
                this.controller.ok(this.coating);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}